import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/additives',
    name: 'POST_ADDITIVE',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
